<template>
  <v-container class="DesignFileType">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2><v-icon large>mdi-file-cad</v-icon>{{ $t('designfile.designfiletype')}}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"

          :to="{ name: 'DesignFileTypeList' }"
        >
          {{ $t('global.back')}}
        </v-btn>
        <v-btn
          v-if="userHasAccess('designfiletype_edit')"
          class="ml-2"
          color="primary"
          :to="{ name: 'DesignFileTypeUpdate' }"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div  v-if="item">
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('global.name') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ item['name'] }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="4" >
              <strong class="ml-4">{{ $t('global.namefr') }}:</strong>
            </v-col>
            <v-col md="8">
              <span class="mr-2">{{ item['namefr'] }}</span>
            </v-col>
          </v-row>

        </v-col>
      </v-row>

    </div>
    </v-sheet>
      <Loading :visible="isLoading" />
  </v-container>

</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';

const servicePrefix = 'DesignFileType';

export default {
  name: 'DesignFileTypeShow',
  servicePrefix,
  components: {
      Loading,
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('designfiletype', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('designfiletype', ['find']),

  },
  methods: {
    ...mapActions('designfiletype', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
